// eslint-disable-next-line no-restricted-imports -- This is a mock of Overlord's function which may use these imports.
import { isAndroid, isIos, isTequila, isWebview } from "@kiwicom/nitro/lib/services/platform/client"

// This function exists in Overlord.
const useSSRFlags = () => {
  return {
    isAndroid: isAndroid(),
    isIos: isIos(),
    isTequila: isTequila(),
    isWebview: isWebview(),
  }
}

export default useSSRFlags
